/**
 * The single place the help mount point is defined. Lives apart from
 * `$lib/help` so content docs can import it without a circular dependency on
 * the glob that imports them.
 */
export const helpPath = (fullSlug: string | null) =>
  `/help/${fullSlug ?? ''}` as const
